import React from "react";
import { graphql } from "gatsby";
import Img from "gatsby-image";
import { injectIntl } from "gatsby-plugin-intl";
import Layout from "../components/layout/Layout";
import Section from "../components/section/Section";
import cssClass from "./article.module.scss";

const Article = ({ data }) => {
  const { name, image, body } = data.contentfulArticle;

  return (
    <Layout>
      <Section className={cssClass.articleHeader}>
        <h1>{name}</h1>
        {image && <Img fluid={image.fluid} alt={image.title} />}
        {body && (
          <div
            dangerouslySetInnerHTML={{
              __html: body.childMarkdownRemark.html,
            }}
          />
        )}
      </Section>
    </Layout>
  );
};

export default injectIntl(Article);

export const query = graphql`
  query($slug: String!, $locale: String) {
    contentfulArticle(slug: { eq: $slug }, node_locale: { eq: $locale }) {
      name
      body {
        childMarkdownRemark {
          html
        }
      }
      image {
        title
        fluid {
          ...GatsbyContentfulFluid_withWebp
        }
      }
    }
  }
`;
